import { getDomainUrl } from 'coreOld/utils';

export const projectsPath = () => '/project';

export const oldProjectListPath = () => `${getDomainUrl()}/project/list`;

export const oldProjectJobListPath = (projectId: number | string = ':projectId') =>
  `${getDomainUrl()}/bom/list?project=${projectId}`;
